import * as React from 'react';

require('../css/progress-steps.css');

interface Props {
  activeIndex: number;
  labels: string[];

  // Adding a property to add external css class. 
  divClassName?: string;
  spanClassName?: string;

  children?: React.ReactChild[];
  onLabelClick(index: number): void;
}

class ProgressStepsVertical extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  renderSubItem = (index: number) => {
    // Check if external css properties comes from parent
    let divUserClass = this.props.divClassName === null ? '' : this.props.divClassName;

    if (this.props.children) {
      return (
        <div className={`${divUserClass}`}>
          {this.props.children[index]}
        </div>
      );
    }
    return null;
  }

  renderSteps = () => {
    return this.props.labels.map((label, index) => {
      let activeClass = this.props.activeIndex === index ? 'active' : '';

      let clickableClass = this.props.activeIndex > index ? 'clickable' : '';
      // Check if external css properties comes from parent
      let spanUserClass = this.props.spanClassName === null ? '' : this.props.spanClassName;
      return (
        <div 
          key={index}
          className={`node ${activeClass} ${clickableClass} ${spanUserClass}`}
          onClick={() => this.props.onLabelClick(index)}
        >
          {this.renderSubItem(index)}
        </div>
      );
    });
  }

  render() {
    return <div className="timeline-wrapper">{this.renderSteps()}</div>;
  }
}

export default ProgressStepsVertical;



// WEBPACK FOOTER //
// ./src/Components/ProgressStepsVertical.tsx